module.exports = new __parcel__URL__("Software Arch Review Hover.e52e609b.svg").toString();